import { UserCommunication } from '@this+that/models';

import { ShortcutContext } from './types';
import { useEmailListActions } from './useEmailListActions';

interface UseInboxTrashActionsProps {
  filteredCommunications: UserCommunication[];
  selectedItems: Set<string>;
  toggleItemSelection: (messageId: string) => void;
  clearSelection?: () => void;
}

export function useInboxTrashActions({
  filteredCommunications,
  selectedItems,
  toggleItemSelection,
  clearSelection,
}: UseInboxTrashActionsProps) {
  useEmailListActions({
    filteredCommunications,
    context: ShortcutContext.TRASH,
    selectedItems,
    toggleItemSelection,
    clearSelection,
  });
}
